import { useSimpleList } from "@refinedev/antd";
import { Skeleton, Grid, Typography, Stack } from "@mui/material";

import { CanvasTile } from "components/canvas";
import { SponsorsBanner } from "components/banners";
import { Canvas } from "types";

export const CanvasList: React.FC = () => {
  const { listProps, queryResult } = useSimpleList<Canvas>({
    resource: "canvases",
    pagination: {
      pageSize: 12,
    },
    sorters: {
      initial: [
        {
          field: "created_at",
          order: "desc",
        },
      ],
    },
  });

  const { isLoading } = queryResult;

  return (
    <div className="container">
      <div className="paper">
        {isLoading ? (
          <div className="canvas-skeleton-list">
            {[...Array(12)].map((_, idx) => (
              <>
                <Skeleton key={idx} width="100%" animation="wave" />
              </>
            ))}
          </div>
        ) : (
          <Grid
            container
            className="canvas-list"
            direction="row"
            justifyContent="center"
            columns={3}
            gap={2}
          >
            {!!listProps?.dataSource?.length ? (
              listProps?.dataSource?.map((canvas) => (
                <CanvasTile key={canvas.id} canvas={canvas} />
              ))
            ) : (
              <Typography
                variant="body1"
                color="GrayText"
                fontWeight="semibold"
                textAlign="center"
                mx="auto"
              >
                No Canvas created! Please create one.
              </Typography>
            )}
          </Grid>
        )}
      </div>
      <SponsorsBanner />
    </div>
  );
};
